import { Theme } from '@mui/material';

const useStyles = (theme: Theme) => ({
  parcelContainer: {
    display: 'flex',
    padding: '12px 16px',
    width: '100%',
    alignItems: 'center',
    justifyContent: 'space-between',
    bgcolor: theme.palette.grey[200],
    borderRadius: '4px',
    boxShadow: '0px 0.85px 3px 0px rgba(0, 0, 0, 0.19), 0px 0.25px 1px 0px rgba(0, 0, 0, 0.04)',
    wrapper: {
      display: 'flex',
      gap: '2px',
      alignItems: 'center',
    },
    text: {
      fontSize: '14px',
      fontWeight: 600,
      textTransform: 'capitalize',
      color: theme.palette.secondary.contrastText,
    },
  },
});

export default useStyles;
